import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`inline-flex items-center justify-center rounded-xl !bg-brand-green px-8 py-4 text-base font-bold tracking-wide !text-white shadow-lg shadow-brand-green/25 transition-[transform,box-shadow,background-color] duration-200 hover:!bg-brand-green/90 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 sm:px-10 sm:py-5 sm:text-lg ${className}`} {...props} data-id="element-116" data-mp="1kcqjtbvyubs3">
      {children}
    </motion.button>;
}